import React, { Component } from 'react';
import PropTypes from 'prop-types';

class AdminLogin extends Component {
  constructor(props) {
    super(props);

    this.handleEnter = this.handleEnter.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentWillMount() {
    document.addEventListener('keydown', this.handleEnter);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEnter);
  }

  handleEnter(event) {
    if (event.keyCode === 13) {
      this.props.login({
        username: this.username,
        password: this.password,
      });
    }
  }

  handleClick() {
    this.props.login({
      username: this.username,
      password: this.password,
    });
  }

  render() {
    return (
      <div className="login-form">
        <div className="field">
          <label className="label">Username</label>
          <div className="control has-icons-left has-icons-right">
            <input
              className="input"
              type="text"
              placeholder="Username"
              onChange={(e) => {
                this.username = e.target.value;
              }}
            />
            <span className="icon is-small is-left">
              <i className="fas fa-user" />
            </span>
          </div>
        </div>
        <div className="field">
          <label className="label">Password</label>
          <div className="control has-icons-left has-icons-right">
            <input
              className="input"
              type="text"
              placeholder="Password"
              onChange={(e) => {
                this.password = e.target.value;
              }}
            />
            <span className="icon is-small is-left">
              <i className="fas fa-key" />
            </span>
          </div>
        </div>
        <div className="field">
          <div className="control">
            <button className="button is-link" onClick={this.handleClick}>
              Login
            </button>
          </div>
        </div>
      </div>
    );
  }
}

AdminLogin.propTypes = {
  login: PropTypes.func.isRequired,
};

export default AdminLogin;



// WEBPACK FOOTER //
// ./src/components/AdminLogin.js